interface ApiErrorShape {
  response?: { data?: { message?: string; error?: string } };
  message?: string;
  requestId?: string | null;
}

export function getErrorMessage(err: unknown, fallback = "Request failed"): string {
  if (err && typeof err === "object") {
    const e = err as ApiErrorShape;
    return (
      e.response?.data?.message ??
      e.response?.data?.error ??
      e.message ??
      fallback
    );
  }
  if (typeof err === "string") return err;
  return fallback;
}

export function getRequestId(err: unknown): string | null {
  if (err && typeof err === "object") {
    const e = err as ApiErrorShape;
    return e.requestId ?? null;
  }
  return null;
}

/**
 * Format an error for display, appending the request ID (if present) so users
 * can quote it when reporting issues.
 */
export function getErrorMessageWithId(err: unknown, fallback = "Request failed"): string {
  const message = getErrorMessage(err, fallback);
  const requestId = getRequestId(err);
  return requestId ? `${message} (Request ID: ${requestId})` : message;
}
